import Layout from '../views/layout/App.vue'
import Empty from '../views/layout/Empty.vue'

export default {
    path: '/audit',
    meta: {
        title: '教研管理',
        keepAlive: false
    },
    component: Layout,
    children: [
        {
            path: '/',
            name: 'list',
            meta: {
                title: '审核列表',
                keepAlive: false
            },
            component: resolve => require(["@/views/audit/examine/index.vue"], resolve),
        }, {
            path: '/audit/testPaperAudit/radioTestA1Detailccc',
            name: 'RadioTestA1Detailys',
            alias: '/radioTestA1Detailccc',
            meta: {
                title: '预览试题',
                keepAlive: false
            },
            component: resolve => require(['@/views/testBaseManage/radioTest/RadioTestA1Detail.vue'], resolve),

        }, {
            path: '/audit/testPaperAudit/radioTestA3Detailccc',
            name: 'RadioTestA3Detailys',
            alias: '/radioTestA3Detailccc',
            meta: {
                title: '预览试题',
                keepAlive: false
            },
            component: resolve => require(['@/views/testBaseManage/radioTest/RadioTestA3Detail.vue'], resolve),

        }, {
            path: '/audit/testPaperAudit/radioTestBDetailccc',
            name: 'RadioTestBDetailys',
            alias: '/radioTestBDetailccc',
            meta: {
                title: '预览试题',
                keepAlive: false
            },
            component: resolve => require(['@/views/testBaseManage/radioTest/RadioTestBDetail.vue'], resolve),

        },
        {
            path: '/audit/knowledgeAudit/knowledgDetail',
            name: 'KnowledgDetailys',
            meta: {
                title: '预览知识点',
                keepAlive: false
            },
            component: resolve => require(['@/views/knowledge/knowledgeList/KnowledgDetail.vue'], resolve)

        },
        {
            path: 'knowledgDetail',
            name: 'knowledgDetailys',
            meta: {
                title: '预览知识点',
                keepAlive: false
            },
            component: Empty,
            children: [{
                path: '/audit/knowledgeAudit/knowledgDetail/radioTestA1Detail',
                name: 'radioTestA1Detaily',
                meta: {
                    title: '预览试题',
                    keepAlive: false
                },
                component: resolve => require(['@/views/testBaseManage/radioTest/RadioTestA1Detail.vue'], resolve),

            }, {
                path: '/audit/knowledgeAudit/knowledgDetail/radioTestA3Detail',
                name: 'RadioTestA3Detaily',
                meta: {
                    title: '预览试题',
                    keepAlive: false
                },
                component: resolve => require(['@/views/testBaseManage/radioTest/RadioTestA3Detail.vue'], resolve),

            }, {
                path: '/audit/knowledgeAudit/knowledgDetail/radioTestBDetail',
                name: 'RadioTestBDetaily',
                meta: {
                    title: '预览试题',
                    keepAlive: false
                },
                component: resolve => require(['@/views/testBaseManage/radioTest/RadioTestBDetail.vue'], resolve),

            }]
        },

        // {
        //     path: 'testPaperAudit',
        //     name: 'TestPaperAudit',
        //     meta: {
        //         title: '试题审核列表',
        //         keepAlive: false
        //     },
        //     component: resolve => require(['@/views/audit/testPaperAudit/Index.vue'], resolve),
        // },
        // {
        //     path: 'testPaperAudit',
        //     name: 'testPaperAudit',
        //     meta: {
        //         title: '试题审核列表',
        //         keepAlive: false
        //     },
        //     component: Empty,
        //     children: [
        //         {
        //             path: '/audit/testPaperAudit/radioTestA1Detailccc',
        //             name: 'RadioTestA1Detailys',
        //             alias: '/radioTestA1Detailccc',
        //             meta: {
        //                 title: '预览试题',
        //                 keepAlive: false
        //             },
        //             component: resolve => require(['@/views/testBaseManage/radioTest/RadioTestA1Detail.vue'], resolve),

        //         }, {
        //             path: '/audit/testPaperAudit/radioTestA3Detailccc',
        //             name: 'RadioTestA3Detailys',
        //             alias: '/radioTestA3Detailccc',
        //             meta: {
        //                 title: '预览试题',
        //                 keepAlive: false
        //             },
        //             component: resolve => require(['@/views/testBaseManage/radioTest/RadioTestA3Detail.vue'], resolve),

        //         }, {
        //             path: '/audit/testPaperAudit/radioTestBDetailccc',
        //             name: 'RadioTestBDetailys',
        //             alias: '/radioTestBDetailccc',
        //             meta: {
        //                 title: '预览试题',
        //                 keepAlive: false
        //             },
        //             component: resolve => require(['@/views/testBaseManage/radioTest/RadioTestBDetail.vue'], resolve),

        //         }
        //     ]
        // },
        // {
        //     path: 'knowledgeAudit',
        //     name: 'KnowledgeAudit',
        //     meta: {
        //         title: '知识点审核列表',
        //         keepAlive: false
        //     },
        //     component: resolve => require(['@/views/audit/knowledgeAudit/Index.vue'], resolve),
        // },
        // {
        //     path: 'knowledgeAudit',
        //     name: 'knowledgeAudit',
        //     meta: {
        //         title: '知识点审核列表',
        //         keepAlive: false
        //     },
        //     component: Empty,
        //     children: [
        //         {
        //             path: '/audit/knowledgeAudit/knowledgDetail',
        //             name: 'KnowledgDetailys',
        //             meta: {
        //                 title: '预览知识点',
        //                 keepAlive: false
        //             },
        //             component: resolve => require(['@/views/knowledge/knowledgeList/KnowledgDetail.vue'], resolve)

        //         },
        //         {
        //             path: 'knowledgDetail',
        //             name: 'knowledgDetailys',
        //             meta: {
        //                 title: '预览知识点',
        //                 keepAlive: false
        //             },
        //             component: Empty,
        //             children: [{
        //                 path: '/audit/knowledgeAudit/knowledgDetail/radioTestA1Detail',
        //                 name: 'radioTestA1Detaily',
        //                 meta: {
        //                     title: '预览试题',
        //                     keepAlive: false
        //                 },
        //                 component: resolve => require(['@/views/testBaseManage/radioTest/RadioTestA1Detail.vue'], resolve),

        //             }, {
        //                 path: '/audit/knowledgeAudit/knowledgDetail/radioTestA3Detail',
        //                 name: 'RadioTestA3Detaily',
        //                 meta: {
        //                     title: '预览试题',
        //                     keepAlive: false
        //                 },
        //                 component: resolve => require(['@/views/testBaseManage/radioTest/RadioTestA3Detail.vue'], resolve),

        //             }, {
        //                 path: '/audit/knowledgeAudit/knowledgDetail/radioTestBDetail',
        //                 name: 'RadioTestBDetaily',
        //                 meta: {
        //                     title: '预览试题',
        //                     keepAlive: false
        //                 },
        //                 component: resolve => require(['@/views/testBaseManage/radioTest/RadioTestBDetail.vue'], resolve),

        //             }]

        //         }
        //     ]
        // }
    ]
}
